export const ZIPCODE_LENGTH = 5;
export const POSTAL_CODE_REGEX = /^\d{5}(?:[-]\d{4})?$/;
